import React from 'react';
import { useTranslation } from '../hx/useTranslation';
import * as FxLog from '../fx/FxLog';
import * as FxDat from '../fx/FxDat';
import CxDlgTable from '../cx/CxDlgTable';
import MxClientOTF from '../modules/common/otf/MxClientOTF';
import { isApp } from "../gx/GxStore";

/** Selector independiente lanzado desde código, por ejemplo para seleccionar cliente o empleado sin necesitar un CxSearcher */
const GxDlgSelectClient = (props) => {
  const [{ trans }] = useTranslation();
  const { onSelect, onClientChanged, hasButtonAdd } = props;

  const r_dlg = React.useRef(null);

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);
  
  const [intermediateValues, setIntermediateValues] = React.useState(null); //para guardar estructura de valores intermedios.
  const [includeAnimal, setIncludeAnimal] = React.useState(props.includeAnimal && (isApp('vett') || isApp('spaw')));

  const [dlg, setDlg] = React.useState(false);

  const r_dlg_new_client = React.useRef(null);

  const hasColumnIc = () => { return Boolean(localStorage.getItem('GxDlgSelectClient.addcol_txIc') === '1') };
  const hasColumnCode = () => { return Boolean(localStorage.getItem('GxDlgSelectClient.addcol_txCode') === '1') };
  const hasColumnReference = () => { return Boolean(localStorage.getItem('GxDlgSelectClient.addcol_txReference') === '1') };
  const hasColumnEmail = () => { return Boolean(localStorage.getItem('GxDlgSelectClient.addcol_txEmail') === '1') };
  const hasColumnMobile = () => { return Boolean(localStorage.getItem('GxDlgSelectClient.addcol_txMobile') === '1') || (!includeAnimal) };
  const hasColumnPhone1 = () => { return Boolean(localStorage.getItem('GxDlgSelectClient.addcol_txPhone1') === '1') };
  const hasColumnPhone2 = () => { return Boolean(localStorage.getItem('GxDlgSelectClient.addcol_txPhone2') === '1') };
  const hasColumnAnimalNumber = () => { return Boolean(localStorage.getItem('GxDlgSelectClient.addcol_txNumber') === '1') }; // VETT, SPAW
  const hasColumnAnimalChip = () => { return Boolean(localStorage.getItem('GxDlgSelectClient.addcol_txChip') === '1') }; // VETT, SPAW
  const hasColumnAnimalPassport = () => { return Boolean(localStorage.getItem('GxDlgSelectClient.addcol_txPassport') === '1') }; // VETT, SPAW


  React.useImperativeHandle(props.xref, () => {
    return {
      setIncludeAnimal, setOpen, setIntermediateValues, search
    };
  });

  const search = () => {
    setOpen(true);
  }

  const setOpen = (boOpen) => {
    if (boOpen) {
      Promise.all([setDlg(true)]).then((result) => {
        r_dlg.current.getTable().redisplay(); // 2025-01-29 - daq: para que al volver a abrirlo no recuerde la página vieja
      });
    } else {
      setDlg(false);
    }
  };

  const getTableOptionalCols = () => {
    let cols = [];
    cols.push({ id: 'txIc', name: trans('field.client') + '-' + trans('field.ic') + " +🔍︎", checked: hasColumnIc() ? '1' : '0' });
    cols.push({ id: 'txCode', name: trans('field.client') + '-' + trans('field.code') + " +🔍︎", checked: hasColumnCode() ? '1' : '0' });
    cols.push({ id: 'txReference', name: trans('field.client') + '-' + trans('field.reference') + " +🔍︎", checked: hasColumnReference() ? '1' : '0' });
    cols.push({ id: 'txEmail', name: trans('field.client') + '-' + trans('field.email') + " +🔍︎", checked: hasColumnEmail() ? '1' : '0' });
    includeAnimal && cols.push({ id: 'txMobile', name: trans('field.client') + '-' + trans('field.mobile') + " +🔍︎", checked: hasColumnMobile() ? '1' : '0' });
    cols.push({ id: 'txPhone1', name: trans('field.client') + '-' + trans('field.phone1') + " +🔍︎", checked: hasColumnPhone1() ? '1' : '0' });
    cols.push({ id: 'txPhone2', name: trans('field.client') + '-' + trans('field.phone2') + " +🔍︎", checked: hasColumnPhone2() ? '1' : '0' });
    if (includeAnimal) {
      cols.push({ id: 'txNumber', name: trans('field.patient') + '-' + trans('field.number') + " +🔍︎", checked: hasColumnAnimalNumber() ? '1' : '0' });
      cols.push({ id: 'txChip', name: trans('field.patient') + '-' + trans('field.chip') + " +🔍︎", checked: hasColumnAnimalChip() ? '1' : '0' });
      cols.push({ id: 'txPassport', name: trans('field.patient') + '-' + trans('field.passport') + " +🔍︎", checked: hasColumnAnimalPassport() ? '1' : '0' });
    } else {
    }
    return cols;
  }

  const getTooltip = () => {
    let tip = '';
    if (includeAnimal) {
      tip = `${trans('field.client')}${' / ' + trans('field.patient')}`;
      if (hasColumnAnimalNumber()) tip = tip + `${' / ' + trans('field.number')}`;
      if (hasColumnAnimalChip()) tip = tip + `${' / ' + trans('field.chip')}`;
      if (hasColumnAnimalPassport()) tip = tip + `${' / ' + trans('field.passport')}`;
    } else {
      tip = `${trans('field.client')}`;
    }
    if (hasColumnIc()) tip = tip + `${' / ' + trans('field.ic')}`;
    if (hasColumnCode()) tip = tip + `${' / ' + trans('field.code')}`;
    if (hasColumnReference()) tip = tip + `${' / ' + trans('field.reference')}`;
    if (hasColumnEmail()) tip = tip + `${' / ' + trans('field.email')}`;
    if (hasColumnMobile()) tip = tip + `${' / ' + trans('field.mobile')}`;
    if (hasColumnPhone1()) tip = tip + `${' / ' + trans('field.phone1')}`;
    if (hasColumnPhone2()) tip = tip + `${' / ' + trans('field.phone2')}`;

    return tip;
  }

  const optionsSelected = (options) => {
    localStorage.setItem('GxDlgSelectClient.addcol_txIc', options.includes('txIc') ? '1' : '0');
    localStorage.setItem('GxDlgSelectClient.addcol_txCode', options.includes('txCode') ? '1' : '0');
    localStorage.setItem('GxDlgSelectClient.addcol_txReference', options.includes('txReference') ? '1' : '0');
    localStorage.setItem('GxDlgSelectClient.addcol_txEmail', options.includes('txEmail') ? '1' : '0');
    localStorage.setItem('GxDlgSelectClient.addcol_txMobile', options.includes('txMobile') ? '1' : '0');
    localStorage.setItem('GxDlgSelectClient.addcol_txPhone1', options.includes('txPhone1') ? '1' : '0');
    localStorage.setItem('GxDlgSelectClient.addcol_txPhone2', options.includes('txPhone2') ? '1' : '0');
    localStorage.setItem('GxDlgSelectClient.addcol_txNumber', options.includes('txNumber') ? '1' : '0');
    localStorage.setItem('GxDlgSelectClient.addcol_txChip', options.includes('txChip') ? '1' : '0');
    localStorage.setItem('GxDlgSelectClient.addcol_txPassport', options.includes('txPassport') ? '1' : '0');
    r_dlg.current.getTable().setTooltipText(getTooltip());
    r_dlg.current.getTable().clearSearch();
    forceUIUpdate();
  }

  const getTableColumns = () => {
    let cols = [];
    try {
      let id = -1;
      cols.push({ id: id++, Header: "ID", accessor: "inClient", show: false });
      cols.push({ id: "txClient",    Header: trans('field.client'),    accessor: "txClient",    highlight: true, width: '30%' });
      cols.push({ id: "txIc",        Header: trans('field.ic'),        accessor: "txIc",        highlight: true, width: '15%', show: hasColumnIc() });
      cols.push({ id: "txCode",      Header: trans('field.code'),      accessor: "txCode",      highlight: true, width: '15%', show: hasColumnCode() });
      cols.push({ id: "txReference", Header: trans('field.reference'), accessor: "txReference", highlight: true, width: '15%', show: hasColumnReference() });
      cols.push({ id: "txEmail",     Header: trans('field.email'),     accessor: "txEmail",     highlight: true, width: '15%', show: hasColumnEmail() });
      cols.push({ id: "txMobile",    Header: trans('field.mobile'),    accessor: "txMobile",    highlight: true, width: '15%', show: hasColumnMobile() });
      cols.push({ id: "txPhone1",    Header: trans('field.phone1'),    accessor: "txPhone1",    highlight: true, width: '15%', show: hasColumnPhone1() });
      cols.push({ id: "txPhone2",    Header: trans('field.phone2'),    accessor: "txPhone2",    highlight: true, width: '15%', show: hasColumnPhone2() });
      if (includeAnimal) {
        cols.push({ id: "inAnimal", Header: '_inAnimal', accessor: row => row["animal_inAnimal"], show: false });
        cols.push({ id: "txAnimal", Header: trans('field.patient'), accessor: "animal_txAnimal",
          Cell: ({ value, row }) => r_dlg.current.getTable().cellFormat(value, `ht|${FxDat.isExpired(row.original.animal_dtTo) ? 'colorA' : ''}`, "txAnimal"),
          width: '15%' });
        cols.push({ id: "txNumber", Header: trans('field.number'), accessor: "animal_txNumber",
          Cell: ({ value, row }) => r_dlg.current.getTable().cellFormat(value, `ht|${FxDat.isExpired(row.original.animal_dtTo) ? 'colorA' : ''}`, "txNumber"),
          width: '15%', show: hasColumnAnimalNumber() });
        cols.push({ id: "txChip", Header: trans('field.chip'), accessor: "animal_txChip",
          Cell: ({ value, row }) => r_dlg.current.getTable().cellFormat(value, `ht|${FxDat.isExpired(row.original.animal_dtTo) ? 'colorA' : ''}`, "txChip"),
          width: '15%', show: hasColumnAnimalChip() });
        cols.push({ id: "txPassport", Header: trans('field.passport'), accessor: "animal_txPassport",
          Cell: ({ value, row }) => r_dlg.current.getTable().cellFormat(value, `ht|${FxDat.isExpired(row.original.animal_dtTo) ? 'colorA' : ''}`, "txPassport"),
          width: '15%', show: hasColumnAnimalPassport() });
      }
      cols.push({ id: "A", Header: "inactive", accessor: row => FxDat.isExpired(row["dtTo"]), show: false });
      cols.push({ id: "R", Header: "balance", accessor: row => Boolean((row["theBalance"]) < 0 ? true : false), show: false });

    } catch (error) {
      FxLog.errorx('GxDlgSelectClient.getTableColumns', error)
    }
    return cols;
  }

  return (
    <div>

      <CxDlgTable
        xref={r_dlg}
        title={props.title || trans('msg.select_x', includeAnimal ? `${trans('field.client')} / ${trans('field.patient')}` : `${trans('field.client')}`)}
        hasSearchBox={true}
        open={dlg}
        onButtonAddOTF={hasButtonAdd && (() => {
          setDlg(false);
          r_dlg_new_client.current.setDlg(true);
        })}
        onClose={() => setDlg(false)}
        onSelect={(row) => {
          if (onSelect) {
            onSelect(row, intermediateValues);
            setDlg(false);
          }
        }}
        url={'clients'}
        tooltip={getTooltip()}
        refColors={[
          `table_cell_color_red|${trans('field.debtor')}`,
          `table_cell_color_gray|${trans('field.inactive')}`,
        ]}
        columns={getTableColumns()}
        optionalColumns={getTableOptionalCols()}
        onOptions={optionsSelected}
        height='450px'
        forceOptions
      />

      <MxClientOTF xref={r_dlg_new_client} onOk={(inClient, txClient) => {
        if (onSelect) {
          let row = { original: { inClient: inClient, txClient: txClient } };
          onSelect(row, intermediateValues);
        }
        if (onClientChanged) {
          onClientChanged(inClient, txClient);
        }
      }} />

    </div>
  );
}

export default GxDlgSelectClient;